import React, { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import Switch from 'components/Switch/Switch';
import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { OPACITY_OPTIONS } from '../../../utils/blockForms.utils';
import { templateStudioSchema } from '../../../validation-schema';
import { DesignBlockMenuItem } from '../Components/DesignBlockMenuItem';

export const TemplateStudioFooterForm: React.FC = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors, touchedFields }
  } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const footerOpacity = watch('footer.backgroundOpacity');
  const defaultSelectedOpacity = useMemo(
    () =>
      OPACITY_OPTIONS.find((option) => option.value === (footerOpacity ?? 100)),
    [footerOpacity]
  );

  return (
    <DesignBlockMenuItem blockType={'footer'}>
      <FormField
        control={control}
        name="footer.showAppchargeLogo"
        render={({ field }) => (
          <Switch
            key={field.value ? 'on' : 'off'}
            label="Show AppCharge Logo"
            textAlignment="left"
            defaultChecked={field.value}
            checked={field.value}
            onCheckedChange={field.onChange}
          />
        )}
      />
      {/* todo: ACDEV-17875: bring back after implementation */}
      {/* <FormField
        control={control}
        name="footer.backgroundOpacity"
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormControl>
              <InputSelectDropdown
                label="Background Opacity"
                options={OPACITY_OPTIONS}
                defaultSelected={defaultSelectedOpacity}
                onOptionChange={(selectedValue) =>
                  onChange(Number(selectedValue))
                }
                placeholder="Select opacity"
                isHorizontal={true}
                className="[&>div:last-child]:w-[100px] justify-between items-center"
                buttonClassName={'h-[30px]'}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        name="footer.textColor"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium">Text Color</label>
              <FormControl>
                <div className="[&_.MuiInputAdornment-root]:mr-0 [&_.MuiTextField-root]:!w-[100px] [&_.MuiInputBase-input]:!px-3 [&_.MuiInputBase-input]:!py-2 [&_.MuiInputBase-input]:!pl-0">
                  <AcGradientInput
                    name="footer.textColor"
                    defaultValue={
                      value || { colorOne: '#CB1010', colorTwo: '#FF0000' }
                    }
                    setValue={createColorSetValueHandler(
                      'footer.textColor',
                      () => watch('footer.textColor'),
                      setValue as (name: string, value: any) => void,
                      onChange
                    )}
                    onlySolid={false}
                    circular={true}
                    imgWidth="16px"
                    imgHeight="16px"
                    error={
                      touchedFields.footer?.textColor &&
                      Boolean(errors.footer?.textColor)
                    }
                    helperText={
                      touchedFields.footer?.textColor
                        ? errors.footer?.textColor?.toString()
                        : ''
                    }
                  />
                </div>
              </FormControl>
            </div>
            <FormMessage />
          </FormItem>
        )}
      /> */}
    </DesignBlockMenuItem>
  );
};
